export default "__VITE_ASSET__BAxaWRrx__"